import AppBar from '@material-ui/core/AppBar';
// import AuditTable from './auditTable/AuditTableContainer';
import CudaPaper from 'common/components/CudaPaper';
import DocumentTitle from 'react-document-title'
import Grid from '@material-ui/core/Grid';
import MixedHealthServers from './mixedHealthServers/MixedHealthServersContainer';
import ProblematicServices from './problematicServices/ProblematicServicesContainer';
import ContainersroblematicServices from './containersProblematicServices/ContainersProblematicServicesContainer';
import PropTypes from 'prop-types';
import React from 'react';
import SearchServices from './searchServices/SearchServicesTableContainer';
import SearchServiceId from './searchByLogId/SearchServiceIdContainer';
import ServerTree from './serverTree/ServerTreeContainer';
import Regions from './regions/RegionsContainer';
import Clusters from './clusters/ClustersContainer';
// import Stats from './stats/StatsContainer';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Licenses from './Licenses/LicensesContainer';
import Badge from '@material-ui/core/Badge';

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const StyledBadge = withStyles((theme) => ({
    badge: {
        top:'-2px',
        right: '-28px',
        // border: '1px white solid',
        // width: '18px',
        // height: '18px',
        // backgroundColor:'transparent'
    },
}))(Badge);

const styles = {
    container: {
        padding: '10px 1px',

    },
    graphs: {
        padding: '0px 30px',
        alignSelf: 'flex-start',
        justifyContent: 'space-between',
    },
    logoutLink: {
        color: 'rgb(0, 0, 238)',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    aaa: {
        padding: 0
    },
    root: {
        width: '100%'
    },
    appbar:{ // TODO: this shouldn't be necessary, investiage and fix issue 
        color: '#fff',
        backgroundColor: '#0088CF',
    },

}
class Dashboard extends React.Component {
    state = {
        value: 0,
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    render() {
        const {
            availableIps,
            classes,
            under_maintenance,
            logout,
            username,
            groups,
            expiredAppsCount = 0,
        } = this.props
        const { value } = this.state;

        function hasAccessTo(role) {
            // console.log(groups)
            // Admin can see everything
            if (groups.includes('admin')) return true;

            // Items with no markings are accessible to Technical Support and admins.
            if (role === null && (groups.includes('support') || groups.includes('admin'))) {
                return true;
            }

            // Items marked [CS] are accessible to Customer Services and admins (NOT technical support).
            if (groups.includes(role)) {
                return true;
            }

            return false;
        }

        return (
            <DocumentTitle title='WaaS Support Dashboard' className={classes.aaa}>
                <div className={classes.root}>
                    <Grid container>
                        <Grid item xs={8}>
                            WaaS Support Dashboard
                        </Grid>
                        <Grid item xs={2}>
                            {username}
                        </Grid>
                        <Grid item xs={2}
                            style={{ textAlign: 'right', flex: 1 }}>
                            <span onClick={logout} className={classes.logoutLink}>
                                Logout
                            </span>
                        </Grid>

                        <Grid item xs={12} style={{ marginTop: '10px' }}>
                            <AppBar position="static" className={classes.appbar}>
                                <Tabs value={value} onChange={this.handleChange}>
                                    <Tab label="General" />
                                    <Tab label="Search" />
                                    {(hasAccessTo('customer_services') || hasAccessTo('support')) &&
                                        <Tab label={ expiredAppsCount > 0 ? 
                                            <StyledBadge badgeContent={expiredAppsCount} color="error">
                                                <div>Licenses</div>
                                            </StyledBadge>
                                            : 
                                            <div>Licenses</div>
                                        } />
                                    }
                                    {/* {hasAccessTo('admin') &&
                                        <Tab label="Stats" />
                                    } */}
                                </Tabs>
                            </AppBar>
                            {value === 0 && 
                            <TabContainer>
                                <Grid container item xs={12} alignItems="stretch" >
                                    <Grid container item xs={12}>
                                        <Grid container item xs={6} direction="column" alignItems="stretch">
                                            {(hasAccessTo('customer_services') || hasAccessTo('support')) &&
                                            <Grid item xs={12} style={{ flex: 1, padding: '10px', paddingTop: '20px', paddingBottom: '0px' }}>
                                                <ContainersroblematicServices />

                                            </Grid>}
                                            
                                            {(hasAccessTo('customer_services') || hasAccessTo('support')) &&
                                            <Grid item xs={12} style={{ flex: 1, padding: '10px' }}>
                                                <ProblematicServices />

                                            </Grid>}
                                        </Grid>

                                        <Grid container item xs={6} direction="column" alignItems="stretch">
                                            <Grid item xs={12} style={{ flex: 0, padding: '10px', paddingBottom: '0px' }}>
                                                <CudaPaper loading={false} padding>
                                                    {hasAccessTo('admin') &&
                                                        <div>
                                                            Available IPs left: {availableIps}
                                                        </div>
                                                    }
                                                    Is in global maintenance now? {under_maintenance ? "True" : "False"}
                                                </CudaPaper>
                                            </Grid>

                                            {hasAccessTo('admin') &&
                                                <Grid item xs={12} style={{ flex: 0, padding: '10px' }}>
                                                    <ServerTree />
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>

                                    {(hasAccessTo('customer_services') || hasAccessTo('support')) &&
                                    <Grid item xs={12} style={{ padding: '10px', paddingTop: '20px' }}>
                                        <Clusters />
                                    </Grid>}

                                    {hasAccessTo('admin') &&
                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                        <Regions />
                                    </Grid>}

                                    {hasAccessTo('customer_services') &&
                                        <Grid item xs={12} style={{ padding: '10px' }}>
                                            <MixedHealthServers />
                                        </Grid>
                                    }

                                
                                </Grid>
                            </TabContainer>}
                            {value === 1
                                && <TabContainer>
                                    <Grid item xs={12}>
                                        <SearchServices />
                                        <SearchServiceId />
                                    </Grid>
                                </TabContainer>}
                            {value === 2
                                && (hasAccessTo('customer_services') || hasAccessTo('support'))
                                && <TabContainer>
                                    <Licenses />
                                </TabContainer>}

                            {/* {value === 3
                                && hasAccessTo('admin')
                                && <TabContainer>
                                    <Stats />
                                </TabContainer>} */}
                        </Grid>







                        {/* <Grid item xs={12}>
                            <ServiceStatusTable/>
                        </Grid> */}



                        {/* <Grid item xs={12}>
                        DC (info per DC, indented per ESXi, not by FDC)
        
                        in/out of BGP      
        
                        is in global maintenance now?
                            { role === 'Admin' &&
                            <div>
                            FDC
                            traffic status (global in/out bits)
                            </div>
                            }
        ! ESXi
        WAFs
        ! CPU load
        WAF Version
        is active? (out/in permanent/temporary load balancing )
        how many services on WAF (one number)
        show what services are configured on this WAF and what port each  (laaaaarge table!)
        
                        </Grid> */}

                        {/* { hasAccessTo('Admin') &&
                        <Grid item xs={12}>
                            <AuditTable/>
                        </Grid>
                        } */}


                    </Grid>
                </div>
            </DocumentTitle>

        );


    }

};

export default withStyles(styles)(Dashboard);   